import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import EmployeeFolder from "../features/employee_folder";

// profil collaborateur
export const employeeFolderRoutes = (
    <Route
        path={ROUTES.employee_folder.route}
        element={<EmployeeFolder />}
        key="employee_folder"
    />
);
